import {
  Nightlight,
  LightMode,
  KeyboardArrowRight,
  KeyboardArrowDown,
} from "@mui/icons-material";
import { Box, Drawer, Tab, Tabs, Typography } from "@mui/material";
import { CalendarDrawer } from "features/searchStore/components/CalendarDrawer";
import { useState } from "react";

export function MReservationSection() {
  const [openCalendar, setOpenCalendar] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleCalendarDrawerClose = () => {
    setOpenCalendar(false);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      px={2}
      bgcolor="white"
      marginTop={1}
    >
      <Typography fontWeight="bold" variant="h5" sx={{ my: 2 }}>
        レストラン予約
      </Typography>
      <Tabs
        style={{ height: "38px", minHeight: "38px" }}
        value={tabValue}
        onChange={handleTabChange}
        variant="fullWidth"
      >
        <Tab
          style={{ height: "30px", minHeight: "30px" }}
          icon={<Nightlight />}
          iconPosition="start"
          label="ディナー"
        />
        <Tab
          style={{ height: "30px", minHeight: "30px" }}
          icon={<LightMode />}
          iconPosition="start"
          label="ランチ"
        />
      </Tabs>

      <Box
        p={1}
        my={1}
        border={1}
        borderRadius={1}
        borderColor="divider"
        display="flex"
        onClick={() => setOpenCalendar(true)}
      >
        <Box display="flex" flex={1}>
          <Typography
            fontWeight="bold"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            席のみ予約
          </Typography>
          <span>
            <Typography
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              （食事は当日にご注文）
            </Typography>
          </span>
        </Box>
        <KeyboardArrowRight color="primary" />
      </Box>

      <Drawer
        key="calendar-drawer"
        anchor="bottom"
        open={openCalendar}
        onClose={handleCalendarDrawerClose}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
        }}
        PaperProps={{
          sx: {
            borderRadius: "12px 12px 0px 0px",
          },
        }}
      >
        <>
          <Box
            display="flex"
            justifyContent="center"
            width="100%"
            onClick={handleCalendarDrawerClose}
          >
            <KeyboardArrowDown fontSize="large" />
          </Box>
          <CalendarDrawer handleClose={handleCalendarDrawerClose} />
        </>
      </Drawer>
    </Box>
  );
}
